import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { timeout, catchError, map, tap } from 'rxjs/operators';
import { Route } from '../interfaces/route';
import { MessageService } from '../services/message.service';
import { BehaviorSubject } from 'rxjs';
import { GlobalVariables } from '../common/global-variables';

const routesUrl = "assets/json/routes.json";

@Injectable({
  providedIn: 'root'
})
export class RouteService {


  private maxCols: number = 5;

  private alertSummaryUrl = 'https://www3.septa.org/api/Alerts/';
  //private alertDetailsUrl = 'https://www3.septa.org/hackathon/Alerts/get_alert_data.php?callback=jsonp_callback1';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  public systemStatus: any = [];
  public routes: Route[] = [];
  public selected: Route[] = [];
  public realtime: boolean = true;
  public detailed: any = { id: 'rr_route_apt', name: 'Aiport', mode: 'Regional Rail' };
  private data: any = [];
  public user = new BehaviorSubject<Route[]>(this.selected);
  cast = this.user.asObservable();

  constructor(
    private http: HttpClient,
    private messageService: MessageService) {

    var stored = JSON.parse(localStorage.getItem("selectedRoutes"));

    if (stored != null) {
      this.selected = stored;
    }

    this.user.next(this.selected);
    var detailed = JSON.parse(localStorage.getItem("detailRoute"));

    if (detailed != null) {
      this.detailed = detailed;
    }
  }

  /** GET routes from api */
  get(): Observable<any[]> {

    this.data = this.http.jsonp<any[]>(this.alertSummaryUrl, 'callback')
      .pipe(
        timeout(GlobalVariables.timeout),
        map((array: any) => array = this.transform(array)),
        tap(_ => this.log('fetched routes')),
        catchError(this.handleError<Route[]>('get', []))
      );
    this.routes = this.data;
    return this.data;
  }

  /** GET routes from static file */
  getStatic(id: string): Observable<any[]> {

    this.data = this.http.get(routesUrl)
      .pipe(
        map((array: any) => array = this.search(array, id)),
        tap(_ => this.log('fetched routes')),
        catchError(this.handleError<Route[]>('get', []))
      );
    this.routes = this.data;
    return this.data;
  }
  

  getAlerts() {
    return this.routes;
  }

  select(routes: Route[]) {
    this.selected = routes;
    this.user.next(this.selected);
    this.getSelected();
    localStorage.setItem("selectedRoutes", JSON.stringify(this.selected));
  }

  detail(route: Route) {
    this.detailed = route;
    localStorage.setItem("detailRoute", JSON.stringify(this.detailed));
  }

  private search(response: any, stop: string): any {
    var searched: any[] = [];
    for (const array of response) {
      if (this.searchArray(array, stop)) {
        searched.push(array);
      }
    }
    return searched;
  }

  private searchArray(array: any, stop: string) {
    for (let i in array) {
      if (i == 'route') {
        if (array[i].toLowerCase() == stop.toLowerCase()) {
          return true;
        }
      }
    }

    return false;
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<any> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      //Mark relatime as false to display the error message.
      this.realtime = false;

      //Load the stored routes.json show no data message.
      return this.http.get(routesUrl)
        .pipe(
          map((array: any) => array = this.transform(array)),
          tap(_ => this.log('fetched routes')),
          catchError(this.handleError<Route[]>('get', []))
        );
    };
  }

  private Failure<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }


  /** Log a RouteService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`RouteService: ${message}`);
  }

  /** Transform the alert summary api to new structure */
  private transform(response: any) {
    var transformed: Route[] = [];
    for (const d of (response as any)) {
      transformed.push({
        id: d.route,
        legacy: d.route,
        name: d.route_name.replace('/', ' '),
        mode: d.mode,
        sequence: d.sequence,
        description: d.description,
        alert: (d.alert != '') ? d.alert : 'There are currently no alerts for this route.',
        advisory: (d.advisory != '') ? d.advisory : 'There are currently no advisories for this route.',
        detours: d.detour,
        elevators: d.elevator,
        isalert: (d.isalert === 'N') ? false : true,
        isadvisory: (d.isadvisory === 'No') ? false : true,
        isdetour: (d.isdetour === 'N') ? false : true,
        isdelays: (d.isdelays === 'N') ? false : true,
        iselevator: (d.iselevator === 'N') ? false : true,
        isweather: (d.isSnow === 'N') ? false : true,
        issuspended: (d.issuspended === 'N') ? false : true
      });
    }
    return transformed;
  }

  transformDetails(reponse: any) {

    var sequence: number = 0;
    var alert: string = '';
    var advisory: string = '';
    var detours: any[] = [];

    for (const d of (reponse as any)) {
      if (d.route_id == d.route_id) {
        sequence = d.sequence;
        alert = d.message;
        advisory = d.advisory_message;
        detours.push(d.detour_message);
      }
    }
  }

  transformStatus(routes: any) {
    var bi: number = 0;
    var ri: number = 0;

    var buses: any = [];
    var rail: any = [];

    for (const route of routes) {
      if (route.mode = 'Bus') {
        buses.push(route);

        if (bi == this.maxCols) {
          this.systemStatus[route.mode].push(buses);
          buses = [];
          bi = 0;
        }

        bi++;
      }
    }
  }

  public getSelected(): any {
    const selectedObservable = new Observable(observer => {
      setTimeout(() => {
        observer.next(this.selected);
      }, 1000);
    });

    return selectedObservable;
  }

  public getStaticRoute(id: string): Observable<any[]> {

    this.data = this.http.get(routesUrl)
      .pipe(
        map((array: any) => array = this.search(array, id)),
        tap(_ => this.log('fetched routes')),
        catchError(this.handleError<Route[]>('get', []))
      );
    this.routes = this.data;
    return this.data;
  }

  public getRoute(): any {
    const selectedObservable = new Observable(observer => {
      setTimeout(() => {
        observer.next(this.selected);
      }, 1000);
    });

    return selectedObservable;
  }
}
